import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

const HISTORY_VIEWS = [
  { value: "billing/invoices", label: "History" },
  { value: "billing/transactions", label: "Payments" },
] as const;

const BillingHistoryLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeView = location.pathname.includes("/billing/transactions") ? "billing/transactions" : "billing/invoices";

  const showView = (value: string) => {
    navigate(`/manage-organisation/${value}`);
  };

  return (
    <div className="text-foreground">
      <div className="container px-4 pt-4">
        <div className="inline-flex items-center gap-1 rounded-lg border bg-card p-1">
          {HISTORY_VIEWS.map((view) => {
            const isActive = view.value === activeView;
            return (
              <button
                key={view.value}
                type="button"
                aria-pressed={isActive}
                onClick={() => showView(view.value)}
                className={cn(
                  "rounded-md border px-3.5 py-1.5 text-sm font-medium",
                  isActive
                    ? "border-primary bg-primary/10 text-primary"
                    : "border-transparent text-muted-foreground hover:bg-muted",
                )}
              >
                {view.label}
              </button>
            );
          })}
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default BillingHistoryLayout;
